import React from "react";

const AddDisciplineModal = () => {
  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="discipline_toevoegen_modal"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Nieuw Discipline</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <label>Naam discipline*</label>
            <input
              id="discipline_naam"
              type="input"
              className="form-control"
              placeholder="Naam discipline"
            />
            <label>Actief</label>
            <label className="switch">
              <input id="discipline_active" type="checkbox" defaultChecked />
              <span className="slider-checkbox round" />
            </label>
            <br />
            <br />
          </div>
          <div className="modal-footer">
            <button type="button" id="save_discipline" className="btn-modal">
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDisciplineModal;
